
export const alertConstant = {
  ALERT_SUCCESS: "ALERT_SUCCESS",
  ALERT_INFO: "ALERT_INFO",
  ALERT_ERROR: "ALERT_ERROR",
  ALERT_CLEAR: "ALERT_CLEAR"
};
